<div class="enrollment-wrapper">
  <div class="heading">
    <h1>
      {{ "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.SMS.TITLE" | translate }}
    </h1>
    <p>
      {{ "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.SMS.SUB_TITLE" | translate }}
    </p>
  </div>

  <!-- screen 1 -->
  <div class="screen-1" *ngIf="(page$ | async) === 'screen1'">
    <!-- will render the form -->
    <dynamic-form
      [fields]="forms.mobile.fields"
      [options]="forms.mobile.formOptions"
      [isSubmitted]="isSubmitBtnClicked"
      [refreshEnabled]="true"
      (onSubmit)="_initiateSMSProcess($event)"
    ></dynamic-form>
    <ng-container *ngIf="(errorState$ | async)?.message"><span class="mat-error">{{((errorState$ | async)?.message||'')  | translate}}</span></ng-container>
    <!-- buttons for the forms -->
    <ng-container *ngTemplateOutlet="btnGroupMobile"></ng-container>
  </div>
  <!-- end of screen 1 -->

  <!-- screen 2 -->
  <div class="screen-2" *ngIf="(page$ | async) === 'screen2'">
    <div class="screen-2-content">
      <div class="icon">
        <cid-mfa-icon [type]="'sms'" [status]="((successState$ | async)?.ph_id) ? 'success': ((errorState$ | async)?.message) ? 'error' : '' " ></cid-mfa-icon>
      </div>
      <div class="contents">
        <div class="form">
          <!-- will render the form -->
          <dynamic-form
          [fields]="forms.otp.fields"
          [options]="forms.otp.formOptions"
          [isSubmitted]="isSubmitBtnClicked"
          [refreshEnabled]="true"
          (onSubmit)="_verifySMSEnrolment($event)"
          ></dynamic-form>
          <ng-container *ngIf="(errorState$ | async)?.message"><span class="mat-error">{{((errorState$ | async)?.message||'')  | translate}}</span></ng-container>
          <!-- buttons for the forms -->
          <ng-container *ngTemplateOutlet="btnGroupOtp"></ng-container>
        </div>
      </div>
    </div>


  </div>

  <!-- screen 3 -->
  <div class="screen-2" *ngIf="(page$ | async) === 'screen3'">
    <div class="screen-3-content">
      <div class="icon">
        <cid-mfa-icon
          [type]="'sms'"
          [status]="
            ((successState$ | async)?.ph_id)
              ? 'success'
              : (errorState$ | async)?.message
              ? 'error'
              : ''
          "
        ></cid-mfa-icon>
      </div>
      <div class="contents">
        <div class="status">
          <div class="success">
            <span *ngIf="(successState$ | async)?.ph_id">
              {{
                "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.SMS.SUCCESS"
                  | translate
              }}
            </span>
            <div class="error" *ngIf="(errorState$ | async)?.message">
              {{ (errorState$ | async)?.message }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- buttons for the forms -->
    <ng-container *ngTemplateOutlet="btnGroupSuccess"></ng-container>
  </div>
</div>

<!-- button group for the mobile entry form -->
<ng-template #btnGroupMobile>
  <div class="btn-wrapper">
    <div class="btngroup">
      <cid-button
        [btnOption]="forms.mobile.buttons.cancel"
        (clickEvent)="_cancelSMSProcess()"
      ></cid-button>
      <cid-button
        [btnOption]="forms.mobile.buttons.submit"
      ></cid-button>
    </div>
  </div>
</ng-template>

<!-- button group for the otp entry form -->
<ng-template #btnGroupOtp>
  <div class="btn-wrapper">
    <div class="btngroup">
      <cid-button
        [btnOption]="forms.otp.buttons.cancel"
        (clickEvent)="_switchPage('screen1')"
      ></cid-button>
      <cid-button
        [btnOption]="forms.otp.buttons.submit"
        (clickEvent)="_initiateSMSProcess(null)"
      ></cid-button>
    </div>
  </div>
</ng-template>


<!-- button group for the success failure screen -->
<ng-template #btnGroupSuccess>
  <div class="btn-wrapper">
    <div class="btngroup">
      <cid-button *ngIf="(errorState$ | async)?.message"
        [btnOption]="forms.otp.buttons.cancel"
        (clickEvent)="_switchPage('screen1')"
      ></cid-button>
      <cid-button *ngIf="(successState$ | async)?.ph_id"
        [btnOption]="forms.otp.buttons.submit"
        (clickEvent)="_completeSMSProcess()"
      ></cid-button>
    </div>
  </div>
</ng-template>
